import React from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';

export default class FilterCheckbox extends React.PureComponent {
  static propTypes = {
    label: PropTypes.string.isRequired,
    value: PropTypes.bool.isRequired,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    labelCss: PropTypes.string,
  }

  onChange = (e) => {
    this.props.onChange(e.target.checked);
  }

  render() {
    const { label, value } = this.props;
    const id = `id-${kebabCase(label)}`;
    return (
      <fieldset className='o-checkbox'>
        <input
          id={id}
          type="checkbox"
          checked={value}
          onChange={this.onChange}
          disabled={this.props.disabled}
        />
        <label htmlFor={id} className={this.props.labelCss}>
          {label}
        </label>
      </fieldset>
    );
  }
}
